import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=01112e0f&scoped=true"
import script from "@/views/Users/Administrator/CreateDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Administrator/CreateDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Administrator/create-dialog.scss?vue&type=style&index=0&id=01112e0f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01112e0f",
  null
  
)

export default component.exports